export default __webpack_public_path__ + "static/media/BIOLOGIA PDF.2edd2834.pdf";